/*global ga, pyg*/
import React, { Component } from 'react'
// import mobx from 'mobx'
import { observer } from 'mobx-react'
import RaisedButton from 'material-ui/RaisedButton'
import _ from 'lodash'
import doctorsStore from '../stores/doctors.js'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import { hashHistory } from 'react-router'
import myFunctions from '../stores/myFunctions'
// import IconButton from 'material-ui/IconButton';
// import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import ActionHome from 'material-ui/svg-icons/action/home';
import AppBar from 'material-ui/AppBar';
import Dialog from './Dialog';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
// import QueryString from 'query-string';
import Loading from './Loading';
// import PlayCircleOutline from 'material-ui/svg-icons/av/play-circle-outline';
import Share from './Share';

const host_url = "./"
const home = '/m/'

let CardHeaderStyle = { padding: '5px 10px 0px' }
let TitleStyle = { fontSize: '20px', color: "#0B5F86", marginBottom: '2px' }
let CardTextStyle = { padding: '0px 10px 5px' }
let CardHeaderTextStyle = { paddingRight: '25px', width: '90%' }

class DocDetail extends Component {
  constructor(props) {
    super(props)

    this.regStart = this.regStart.bind(this)
    this.home = this.home.bind(this)
    this.link = this.link.bind(this)
    this.videoPlayer = this.videoPlayer.bind(this)
  };

  regStart() {
    ga('send', 'event', '醫生查詢:按下掛號', '按掛號', `${doctorsStore.DocDetail.NameCh}(${doctorsStore.DocDetail.EmpNo})`)
    //location.href = '/register/'
    let strUrl = location.search;
    let getPara, ParaVal;
    let aryPara = [];

    if (strUrl.indexOf("?") != -1) {
      let getSearch = strUrl.split("?");
      getPara = getSearch[1].split("&");
      for (let i = 0; i < getPara.length; i++) {
        ParaVal = getPara[i].split("=");
        aryPara.push(ParaVal[0]);
        aryPara[ParaVal[0]] = ParaVal[1];
      }
    }
    aryPara.app === 'true' ?
    window.postMessage('https://www.kfsyscc.org/public/first_visit', '*') :
    window.open('/public/first_visit/', '_blank')
  }

  link() {
    window.scrollTo(0, 0)
    hashHistory.push('/')
  }

  home() {
    location.href = `${home}`
  }

  componentWillMount() {
    doctorsStore.pathname = this.props.location.pathname
    if (doctorsStore.data === null) {
      doctorsStore.setLoadData(this.props.location.query.n)
    } else {
      return false
    }
  }

  videoPlayer() {
    doctorsStore.open = 'true'
  }

  render() {
    let strUrl = location.search;
    let getPara, ParaVal;
    let aryPara = [];

    if (strUrl.indexOf("?") != -1) {
      let getSearch = strUrl.split("?");
      getPara = getSearch[1].split("&");
      for (let i = 0; i < getPara.length; i++) {
        ParaVal = getPara[i].split("=");
        aryPara.push(ParaVal[0]);
        aryPara[ParaVal[0]] = ParaVal[1];
      }
    }

    if (doctorsStore.data !== null && doctorsStore.DocDetail.EmpNo !== '') {
      let Skills = false
      if (_.size(doctorsStore.DocDetail.Skills) > 2) {
        Skills = true
      }
      let Degree = false
      if (_.size(doctorsStore.DocDetail.Degree) > 2) {
        Degree = true
      }
      let JobPosition = false
      if (_.size(doctorsStore.DocDetail.JobPosition) > 2) {
        JobPosition = true
      }
      let Experience = false
      if (_.size(doctorsStore.DocDetail.Experience) > 2) {
        Experience = true
      }
      let ProAcademy = false
      if (_.size(doctorsStore.DocDetail.ProAcademy) > 2) {
        ProAcademy = true
      }
      let Research = false
      if (_.size(doctorsStore.DocDetail.Research) > 2) {
        Research = true
      }
      let Training = false
      if (_.size(doctorsStore.DocDetail.Training) > 2) {
        Training = true
      }
      const host = `https://patient.kfsyscc.org/images/doctors/${doctorsStore.DocDetail.EmpNo}.jpg?${new Date().getTime()}`

      return (
        <div style={{ marginTop: '0px', float: 'left', width: '100%', backgroundColor: 'white', boxShadow: '0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)', minHeight: '100vh' }}>
          <Dialog />

          <div style={{ width: '100%' }}>
            {
              aryPara.app === 'true' ? null :
                <AppBar
                  title={
                    <div>醫師查詢
                      <span style={{ fontSize: '11px' }}>{myFunctions.version}</span>
                    </div>
                  }
                  style={{ backgroundColor: 'white', textAlign: 'center', height: '44px', position: 'fixed', maxWidth: '414px' }}
                  titleStyle={{ color: 'black', height: '44px', fontWeight: '500', fontSize: '17px', lineHeight: '44px', weight: '46%', textAlign: 'center' }}
                  iconElementLeft={<ChevronLeft onTouchTap={this.link} />}
                  iconElementRight={<ActionHome onClick={this.home} />}
                />
            }

            <Card style={
              aryPara.app === 'true' ?
                { marginBottom: '5px', position: 'fixed', width: '100%', height: '116px', top: '0', maxWidth: '414px' } :
                { marginBottom: '5px', marginTop: '44px', position: 'fixed', width: '100%', height: '116px', top: '0', maxWidth: '414px' }
            }>
              <CardHeader
                title={
                  <div>
                    <span style={{ color: "#0B5F86" }}>{doctorsStore.DocDetail.NameCh} 醫師</span>
                    {((() => {
                      if (doctorsStore.DocDetail.OpdFlag === 'Y') {
                        return false
                        return <RaisedButton
                          label={'掛號'}
                          onClick={this.regStart}
                          labelColor="#FFFFFF"
                          backgroundColor="#F15A24"
                          style={{
                            width: '80px', marginRight: '5px',
                            position: 'absolute', top: '60px', right: '0px',
                            height: '34px', zIndex: '10', padding: '0px', minWidth: '50px'
                          }}
                          labelStyle={{ fontSize: '20px', padding: '0px' }}
                        />
                      } else {
                        return false
                      }
                    })())}

                  </div>
                }
                style={{ marginRight: '20px', fontColor: '#0B5F86' }}
                subtitle={<div style={{ paddingRight: '0px' }}>
                  <span style={{ color: "#0B5F86" }}>{doctorsStore.DocDetail.NameEn}</span>
                  <br />
                  <br />
                  {/*<span onTouchTap={this.videoPlayer.bind(this)}>VideoTEST</span>*/}
                  <div>科別：<span style={{ color: "#0B5F86" }}>{doctorsStore.DocDetail.HdeptSubName}</span></div>
                </div>}
                avatar={
                  <div style={{ width: '80px', height: '80px', overflow: 'hidden', float: 'left', borderRadius: '5px' }}>
                    <img
                      role="presentation"
                      style={{ width: '80px', height: '120px', borderRadius: '5px', padding: 0 }}
                      src={host}
                      alt={doctorsStore.DocDetail.EmpNo}
                      onError={(e) => { e.target.src = `https://patient.kfsyscc.org/images/doctors/default.jpg?${new Date().getTime()}` }} />
                  </div>
                }
                textStyle={{ paddingRight: '0px', width: '60%', float: 'left' }}
              />
            </Card>
            {/* <div style={{ position: 'fixed', bottom: '5', zIndex: '50' }}>
              <Share />
            </div> */}
          </div>

          <div style={aryPara.app === 'true' ? { margin: '121px 10px 0 10px', display: 'block' } : { margin: '165px 10px 0 10px', display: 'block' }}>
            {((() => {
              if (_.size(doctorsStore.DocDetail.Introduce) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>個人自我簡介：</div>}
                      // subtitle={_.slice(_.map(item.Introduce,(item,key)=>{return (<li key={key} style={{color: 'rgba(0, 0, 0, 0.870588)'}}>{item}</li>)}),0,2)}
                      actAsExpander={false}
                      showExpandableButton={false}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={false} style={{ padding: '0px 16px 16px 16px' }}>
                      <div style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>
                        {/*<div onTouchTap={this.videoPlayer} style={{ float: 'right', margin: '3px', position: 'relative', cursor: 'pointer' }} >
                          <PlayCircleOutline
                            style={{
                              position: 'absolute',
                              top: '0',
                              right: '0',
                              bottom: '0',
                              left: '0',
                              margin: 'auto',
                              fill: 'rgba(255, 255, 255, 0.8)',
                            }} />
                          <img
                            role="presentation"
                            src="http://img.youtube.com/vi/Ni_lx_BZpuE/default.jpg"
                          />
                        </div>*/}
                        {doctorsStore.DocDetail.Introduce}</div>
                      <div style={{ display: 'flex' }}>


                      </div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.MedicalTeams) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>團隊：</div>}
                      subtitle={
                        _.map(doctorsStore.DocDetail.MedicalTeams, (item, key) => {
                          return (
                            <li key={key}
                              style={{ color: 'rgba(0, 0, 0, 0.870588)', width: '240px' }}
                            // onTouchTap={doctorsStore.setTeam(item)}
                            // onTouchTap={
                            //   ()=>{ 
                            //     return ()=>{
                            //       <Link to="/"></Link>
                            //       doctorsStore.setTeam(`${item}`)
                            //     }()
                            //   }
                            // }
                            >
                              {item}
                            </li>)
                        })
                      }
                      actAsExpander={false}
                      showExpandableButton={false}
                      textStyle={{ paddingRight: '0px' }}
                    />
                    <CardText expandable={false} style={CardTextStyle}>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.Skills) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>專長：</div>}
                      subtitle={_.slice(_.map(doctorsStore.DocDetail.Skills, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                      actAsExpander={Skills}
                      showExpandableButton={Skills}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={Skills} style={CardTextStyle}>
                      <div>{_.slice(_.map(doctorsStore.DocDetail.Skills, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.Skills.length)}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.Degree) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>學歷：</div>}
                      subtitle={_.slice(_.map(doctorsStore.DocDetail.Degree, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                      actAsExpander={Degree}
                      showExpandableButton={Degree}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={Degree} style={CardTextStyle}>
                      <div>{_.slice(_.map(doctorsStore.DocDetail.Degree, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.Degree.length)}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.JobPosition) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>現職：</div>}
                      subtitle={_.slice(_.map(doctorsStore.DocDetail.JobPosition, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                      actAsExpander={JobPosition}
                      showExpandableButton={JobPosition}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={JobPosition} style={CardTextStyle}>
                      <div>{_.slice(_.map(doctorsStore.DocDetail.JobPosition, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.JobPosition.length)}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.Experience) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>經歷：</div>}
                      subtitle={_.slice(_.map(doctorsStore.DocDetail.Experience, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                      actAsExpander={Experience}
                      showExpandableButton={Experience}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={Experience} style={CardTextStyle}>
                      <div>{_.slice(_.map(doctorsStore.DocDetail.Experience, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.Experience.length)}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.Training) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>研修：</div>}
                      subtitle={_.slice(_.map(doctorsStore.DocDetail.Training, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                      actAsExpander={Training}
                      showExpandableButton={Training}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={Training} style={CardTextStyle}>
                      <div>{_.slice(_.map(doctorsStore.DocDetail.Training, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.Training.length)}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.ProAcademy) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>專業學會：</div>}
                      subtitle={_.slice(_.map(doctorsStore.DocDetail.ProAcademy, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                      actAsExpander={ProAcademy}
                      showExpandableButton={ProAcademy}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={ProAcademy} style={CardTextStyle}>
                      <div>{_.slice(_.map(doctorsStore.DocDetail.ProAcademy, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.ProAcademy.length)}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
            {((() => {
              let arr = doctorsStore.DocDetail.Research
              if (arr === null) return
              let result = arr.some(val=> {
                return typeof val === "object";
              });
              if (_.size(doctorsStore.DocDetail.Research) !== 0) {
                if (result) {
                  return (
                    <Card>
                      <CardHeader
                        style={CardHeaderStyle}
                        title={<div style={TitleStyle}>著作/研究：</div>}
                        actAsExpander={false}
                        showExpandableButton={false}
                        textStyle={CardHeaderTextStyle}
                      />
                      <CardText expandable={false} style={CardTextStyle}>
                        <div>
                          {_.map(doctorsStore.DocDetail.Research, (items, key) => { 
                            return _.map(items, (arrays, title) => {
                              return (
                                <div key={key}>
                                  <p style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{title}</p>
                                  <ol>{_.map(arrays, (text, i) => <li key={i} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{text}</li>)}</ol>
                                </div>
                              )
                            })
                          })}
                        </div>
                      </CardText>
                    </Card>
                  )
                } else {
                  return (
                    <Card>
                      <CardHeader
                        style={CardHeaderStyle}
                        title={<div style={TitleStyle}>著作/研究：</div>}
                        subtitle={_.slice(_.map(doctorsStore.DocDetail.Research, (item, key) => { return (<li key={key} style={{ color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 0, 2)}
                        actAsExpander={Research}
                        showExpandableButton={Research}
                        textStyle={CardHeaderTextStyle}
                      />
                      <CardText expandable={Research} style={CardTextStyle}>
                        <div>{_.slice(_.map(doctorsStore.DocDetail.Research, (item, key) => { return (<li key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</li>) }), 2, doctorsStore.DocDetail.Research.length)}</div>
                      </CardText>
                    </Card>
                  )
                }
              } else {
                return false
              }
            })())}
            {((() => {
              if (_.size(doctorsStore.DocDetail.GoogleScholar) !== 0) {
                return (
                  <Card>
                    <CardHeader
                      style={CardHeaderStyle}
                      title={<div style={TitleStyle}>Google學術研究：</div>}
                      // subtitle={()=>{item.GoogleScholar,(item,key)=>{return (<li key={key} style={{color: 'rgba(0, 0, 0, 0.870588)'}}>{item}</li>)}
                      // subtitle={()=>{return (<div>{item.GoogleScholar}</div>)}}
                      actAsExpander={true}
                      showExpandableButton={true}
                      textStyle={CardHeaderTextStyle}
                    />
                    <CardText expandable={true} style={CardTextStyle}>
                      {/*<a href={item.GoogleScholar} target="_blank">{_.map({item.GoogleScholar})}</a>*/}
                      <div>{_.map(doctorsStore.DocDetail.GoogleScholar, (item, key) => { return (<a href={item} target="_blank" key={key} style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.870588)' }}>{item}</a>) })}</div>
                    </CardText>
                  </Card>
                )
              } else {
                return false
              }
            })())}
          </div>

        </div >
      )
    } else if (doctorsStore.data === 'No Data') {
      return (
        <div style={{ marginTop: '0px', float: 'left', width: '100%' }}>
          <div style={{ width: '100%' }}>
            <AppBar
              title={
                <div>醫師查詢
                  <span style={{ fontSize: '11px' }}>{myFunctions.version}</span>
                </div>
              }
              style={{ backgroundColor: 'white', textAlign: 'center', height: '44px' }}
              titleStyle={{ color: 'black', height: '44px', fontWeight: '500', fontSize: '17px', lineHeight: '44px', weight: '46%', textAlign: 'center' }}
              iconElementLeft={<ChevronLeft onTouchTap={this.link} />}
              iconElementRight={<ActionHome onClick={this.home} />}
            />
            <div style={{ textAlign: 'center', fontSize: '25px' }}>找不到此醫師</div>
          </div>
        </div>
      )
    } else if (doctorsStore.data === null) {
      return (<Loading />)
    } else {
      return false
    }
  }
}


export default observer(DocDetail)



// WEBPACK FOOTER //
// ./src/components/DocDetail.js